import React from "react";
import { Box, Grid, MenuItem, Paper, Typography } from "@mui/material";
import { FormHandles } from "@unform/core";

import { LoadingComp } from "../../../../../shared/components/loading/Loading";
import { VForm, VTextField } from "../../../../../shared/forms";
import { ISimulateEditCancel } from "../../../../../shared/services/api/proposal/ProposalEditService";

interface CancelTabProps {
	formRef: React.RefObject<FormHandles>;
	isLoading: boolean;
	onSubmit: (dados: ISimulateEditCancel) => void;
}

export const CancelTab: React.FC<CancelTabProps> = ({ formRef, isLoading, onSubmit }) => {
	return (
		<Box>
			{isLoading && <LoadingComp isopen />}
			<VForm id="formIdCancelChange" onPointerEnterCapture={''} onPointerLeaveCapture={''} placeholder={''} ref={formRef} onSubmit={onSubmit}>
				<Box margin={0} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0}>
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h6" color={"primary"}>
									Alteração do Cancelamento
								</Typography>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} md={8}>
									<VTextField fullWidth label="Motivo do cancelamento" name="canceledType" disabled={isLoading} select>
										<MenuItem value={"Preço"}>Preço</MenuItem>
										<MenuItem value={"Compra do imóvel"}>Compra do imóvel</MenuItem>
										<MenuItem value={"Desistência da locação"}>Desistência da locação</MenuItem>
										<MenuItem value={"Distrato locador e imobiliária"}>Distrato locador e imobiliária</MenuItem>
										<MenuItem value={"Duplicidade de garantias"}>Duplicidade de garantias</MenuItem>
										<MenuItem value={"Garantia irregular/fraude"}>Garantia irregular/fraude</MenuItem>
										<MenuItem value={"Imissão na posse - Sinistro"}>Imissão na posse - Sinistro</MenuItem>
										<MenuItem value={"Inadimplência (imobiliária)"}>Inadimplência (imobiliária)</MenuItem>
										<MenuItem value={"LMI/LMG atingido"}>LMI/LMG atingido</MenuItem>
										<MenuItem value={"Termo de entrega de chaves - Sinistro"}>Termo de entrega de chaves - Sinistro</MenuItem>
										<MenuItem value={"Termo de entrega de chaves e confissão de dívidas"}>
											Termo de entrega de chaves e confissão de dívidas
										</MenuItem>
										<MenuItem value={"Termo de entrega de chaves e inexistência de débitos - imobiliária"}>
											Termo de entrega de chaves e inexistência de débitos - imobiliária
										</MenuItem>
										<MenuItem value={"Termo de revogação/declaração de responsabilidade"}>
											Termo de revogação/declaração de responsabilidade
										</MenuItem>
										<MenuItem value={"Troca de garantia"}>Troca de garantia</MenuItem>
										<MenuItem value={"Troca de imobiliária/estipulante/administradora"}>
											Troca de imobiliária/estipulante/administradora
										</MenuItem>
										<MenuItem value={"Troca de locatário"}>Troca de locatário</MenuItem>
										<MenuItem value={"Troca de seguradora"}>Troca de seguradora</MenuItem>
										<MenuItem value={"Outros"}>Outros</MenuItem>
									</VTextField>
								</Grid>

								<Grid item xs={12} md={4}>
									<VTextField fullWidth label="Data do cancelamento" name="canceledAt" disabled={isLoading} type="date" />
								</Grid>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12}>
									<VTextField fullWidth label="Descrição do cancelamento" name="canceledReason" disabled={isLoading} multiline rows={4} />
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</VForm>
		</Box>
	);
};
